import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

/**
 * Format a date string (YYYY-MM-DD) for display, avoiding timezone shift issues.
 * Adding T00:00:00 ensures the date is interpreted as local midnight, not UTC.
 */
export function formatDateLocal(dateString, options = {}) {
  if (!dateString) return '-';
  
  // Handle both YYYY-MM-DD and full ISO strings
  const localDate = dateString.includes('T') 
    ? new Date(dateString) 
    : new Date(dateString + 'T00:00:00');
  
  return localDate.toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
    ...options
  });
}

/**
 * Get date value for input fields (YYYY-MM-DD format)
 */
export function getDateInputValue(dateString) {
  if (!dateString) return '';
  // Already in YYYY-MM-DD format
  if (/^\d{4}-\d{2}-\d{2}$/.test(dateString)) return dateString;
  // Parse ISO string to YYYY-MM-DD
  const date = new Date(dateString);
  return date.toISOString().split('T')[0];
}
